import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

// services
import formatter from 'services/formatter';

// assets
import CssCopyrightInfo from './CopyrightInfo.scss';

export class CopyrightInfoComponent extends PureComponent {
  static propTypes = {
    book: PropTypes.shape({
      publication_date: PropTypes.string,
      recipe_copyright_line: PropTypes.string,
      licensor: PropTypes.string,
    }),
  };

  static defaultProps = {
    book: {
      publication_date: '',
      recipe_copyright_line: '',
      licensor: '',
    },
  };

  render() {
    const { book } = this.props;
    const text = formatter.meta.getCopyrightText(book);

    if (text) {
      return (
        <div className="copyright-info">
          <p className="copyright-info__tag">{text}</p>
        </div>
      );
    }
    return null;
  }
}
export default withStyles(CssCopyrightInfo)(CopyrightInfoComponent);
